module.exports = __webpack_public_path__ + "img/pie.2b23b651.png";